<template>
    <div class="wizard__wrap wizard__wrap--final">
        <div class="row jus-c--space-between">
            <!--            <a href="/">Advanced view</a>-->
            <a href="#" @click="onHystoricalData">Hystorical data</a>
        </div>
        <div class="wizard__block wizard__block--final">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>

            <div class="wizard__block-title" style="margin-bottom: 12px">
                Completed
            </div>

            <div class="wizard__block-title" style="margin-top: 12px">
                {{ agencyName }}'s action plan for {{ currentMonth }}
                <span class="subtitle">Please click "Confirm" or edit</span>
                <!-- <span class="subtitle link">
                    <span class="red" @click="onViewSalesHistory">View sales history</span>
                </span> -->
            </div>
                <!-- TODO -->
                <!-- v-if="Number(summary_data.data.collected) < Number(summary_data.data.amount) && summary_data.data.collected" -->
            <div v-if="getCollectedAndAmountFromData(summary_data) && summary_data">
                summery data: A
            </div>
            <div
                class="wizard__block-tasks wizard__block-tasks--final"
                v-if="summary_data"
            >
                <div v-if="summary_data.length">
                    <div class="row">
                        <div
                            class="task"
                            v-for="(task, task_index) in summary_data"
                            v-if="
                                typeof task === 'object' &&
                                !Array.isArray(task) &&
                                task !== null
                            "
                        >
                            <div
                                class="title"
                                v-if="
                                    typeof task === 'object' &&
                                    !Array.isArray(task) &&
                                    task !== null
                                "
                            >
                                <i class="icon icon-checkmark"></i>
                                <div
                                    style="display: inline"
                                    v-html="task.title"
                                ></div>
                            </div>

                            <div
                                class="task-container"
                                v-if="
                                    typeof task === 'object' &&
                                    !Array.isArray(task) &&
                                    task !== null
                                "
                            >
                                <div
                                    v-if="
                                        task.type === 'retainer' ||
                                        task.type === 'project'
                                    "
                                    class="list"
                                    v-for="(subtask, index) in Object.values(
                                        JSON.parse(task.data)
                                    )"
                                >
                                    <div class="table-wrap">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Period</th>
                                                    <th>Type</th>
                                                    <th class="min-w-200">
                                                        Deal
                                                    </th>
                                                    <th>Amount</th>
                                                    <th>Collected</th>
                                                    <th>Hard&nbsp;cost</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="sale in subtask" v-if="typeof sale !== 'string' && subtask !== null">
                                                    <td>
                                                        {{
                                                            getPeriodDate(
                                                                sale.period ||
                                                                    sale.sale
                                                                        .period
                                                            )
                                                        }}
                                                    </td>
                                                    <td>{{ sale.type }}</td>
                                                    <td
                                                        :title="
                                                            Object.keys(
                                                                JSON.parse(
                                                                    task.data
                                                                )
                                                            )[index]
                                                        "
                                                        class="nowrap max-220"
                                                    >
                                                        {{
                                                            Object.keys(
                                                                JSON.parse(
                                                                    task.data
                                                                )
                                                            )[index]
                                                        }}
                                                    </td>
                                                    <td
                                                        :class="
                                                            !isHasChangeValueOfSale(
                                                                sale.changes,
                                                                'Amount'
                                                            )
                                                                ? 'opacity'
                                                                : ''
                                                        "
                                                    >
                                                        ${{
                                                            getValueFromChangesOfSale(
                                                                sale.changes,
                                                                "Amount"
                                                            ) ||
                                                            numberWithCommas(
                                                                sale.amount
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        :class="
                                                            !isHasChangeValueOfSale(
                                                                sale.changes,
                                                                'Collected'
                                                            )
                                                                ? 'opacity'
                                                                : ''
                                                        "
                                                    >
                                                        ${{
                                                            getValueFromChangesOfSale(
                                                                sale.changes,
                                                                "Collected"
                                                            ) ||
                                                            numberWithCommas(
                                                                sale.collected
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        :class="
                                                            !isHasChangeValueOfSale(
                                                                sale.changes,
                                                                'Hard Cost'
                                                            )
                                                                ? 'opacity'
                                                                : ''
                                                        "
                                                    >
                                                        ${{
                                                            getValueFromChangesOfSale(
                                                                sale.changes,
                                                                "Hard Cost"
                                                            ) ||
                                                            numberWithCommas(
                                                                sale.hard_cost
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="red edit"
                                                            style="
                                                                cursor: pointer;
                                                            "
                                                            @click="
                                                                () =>
                                                                    onEditDealSales(
                                                                        sale.id,
                                                                        sale
                                                                            .sale
                                                                            .deal_id,
                                                                        sale.period ||
                                                                            sale
                                                                                .sale
                                                                                .period,
                                                                        sale.sow_index,
                                                                        sale.upsell_index
                                                                    )
                                                            "
                                                            >Edit</span
                                                        >
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-if="
                                                        Object.keys(subtask).length &&
                                                        typeof Object.values(subtask).slice(-1)[0] === 'string'
                                                    "
                                                >
                                                    <td colspan="6">
                                                        Total commission
                                                    </td>
                                                    <td>{{Object.values(subtask).slice(-1)[0] }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div
                                    v-if="task.type === 'invoices'"
                                    class="list"
                                >
                                    <div class="table-wrap">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Period</th>
                                                    <th>Paid&nbsp;date</th>
                                                    <th>Paid&nbsp;amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(
                                                        invoice, index
                                                    ) in Object.values(
                                                        JSON.parse(task.data)
                                                    )"
                                                >
                                                    <td>
                                                        {{
                                                            getPeriodDate(
                                                                invoice.period
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        :class="
                                                            !isHasChangeValueOfSale(
                                                                invoice.changes,
                                                                'Payment Received'
                                                            )
                                                                ? 'opacity'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            getValueFromChangesOfInvoice(
                                                                invoice.changes,
                                                                "Payment Received"
                                                            )
                                                        }}
                                                    </td>
                                                    <td
                                                        :class="
                                                            !isHasChangeValueOfSale(
                                                                invoice.changes,
                                                                'Collected'
                                                            )
                                                                ? 'opacity'
                                                                : ''
                                                        "
                                                    >
                                                        ${{
                                                            getValueFromChangesOfInvoice(
                                                                invoice.changes,
                                                                "Collected"
                                                            ) ||
                                                            numberWithCommas(
                                                                invoice.collected
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="red edit"
                                                            @click="
                                                                onEditInvoices
                                                            "
                                                            >Edit</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div v-if="task.type === 'upsell'" class="list">
                                    <div class="table-wrap">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>SOW</th>
                                                    <th class="min-w-200">
                                                        Service
                                                    </th>
                                                    <th>Type</th>
                                                    <th>Amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(
                                                        upsell, index
                                                    ) in Object.values(
                                                        JSON.parse(task.data)
                                                    )"
                                                >
                                                    <td>
                                                        {{ upsell.sow_name }}
                                                    </td>
                                                    <td class="nowrap">
                                                        {{
                                                            upsell.service_name
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            brand_types[
                                                                upsell.type_id -
                                                                    1
                                                            ]
                                                        }}
                                                    </td>
                                                    <td>
                                                        ${{
                                                            numberWithCommas(
                                                                upsell.amount
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="red edit"
                                                            style="
                                                                cursor: pointer;
                                                            "
                                                            @click="
                                                                () =>
                                                                    onEditUpsell(
                                                                        upsell.sow_index,
                                                                        upsell.upsell_index
                                                                    )
                                                            "
                                                            >Edit</span
                                                        >
                                                        <span
                                                            class="red edit"
                                                            @click="
                                                                () =>
                                                                    onDeleteAction(
                                                                        upsell.id,
                                                                        upsell.sow_name
                                                                    )
                                                            "
                                                            >Delete</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="list"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-footer">
                <div class="row jus-c--center">
                    <button
                        @click="handleConfirmDraft"
                        :disabled="isLoading"
                        class="btn btn-white"
                    >
                        Confirm
                    </button>
                </div>
            </div>

            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>

            <confirm-modal
                v-if="isConfirmDeleteModal"
                :title="`Are you sure want to delete upsell ${deleteNameSow}?`"
                :onApplyAction="onDeleteUpsell"
                :onSecondaryAction="onCancelDelete"
                :applyLabel="'Yes'"
                :secondaryLabel="'No'"
            ></confirm-modal>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { SECTIONS } from "../consts";
import ClipLoader from "vue-spinner/src/ClipLoader";
import ConfirmModal from "../../../components/ConfirmModal";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Final_Dashboard",
    props: ["onConfirm", "onChangeSection"],
    components: {
        ClipLoader,
        ConfirmModal,
    },
    data() {
        return {
            SECTIONS,
            isLoading: false,
            summary_data: [],
            brand_types: ["Monthly", "Full amount", "One-Time Fee"],
            isConfirmDeleteModal: false,
            deleteIdUpsell: null,
            deleteNameSow: "",
        };
    },

    computed: {
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        currentMonth: () => {
            return moment().format("MMMM'YY");
        },
    },

    mounted() {
        this.getData();
        this.$store.commit("setEditDealId", null);
        this.$store.commit("setSalesPagesIndex", 0);
        this.$store.commit("setIsEditUpsell", false);

        scrollToTop();
    },

    methods: {
        getPeriodDate(date = null) {
            if (date.includes("/")) return date;

            console.log(date);
            if (date) {
                return moment(date).format("MM/YYYY");
            }
            return "";
        },
        async getData() {
            try {
                this.isLoading = true;

                await axios
                    .post("/api/wizard/getList", { page: "summary" })
                    .then((res) => {
                        const { data } = res;

                        if (data) {
                            this.summary_data = data.page;
                            return;
                        }

                        this.summary_data = null;
                    })
                    .finally(() => {
                        this.isLoading = false;
                        console.log("summary_data", this.summary_data)
                    });

            } catch (err) {
                console.error(err);
            }
        },
        handleConfirmDraft() {
            this.isLoading = true;

            try {
                axios
                    .post("/api/wizard/confirm")
                    .then(() => {
                        //this.$toast.success("Draft confirmed!");
                        this.onConfirm();
                    })
                    .catch((err) => {
                        this.$toast.error(
                            "Something went wrong. Please check error in browser console"
                        );
                        console.error(err);
                    })
                    .finally(() => (this.isLoading = false));
            } catch (err) {
                console.error(err);
            }
        },

        getCollectedAndAmountFromData(arr) {
            // let isCollectedLess = false
            // arr.forEach(item => {
            //     if (item.data.collected < item.data.amount) {
            //         isCollectedLess = true
            //     }
            // })
            // return isCollectedLess
            return arr.some(item => item.data?.collected < item.data?.amount);
        },

        formatRetainerItemsData(items) {
            let str = "";

            // const keys = Object.keys(items);
            // const values = Object.values(items);

            items.forEach((item) => {
                if (item.name === "Invoiced") {
                    str += `Invoiced: $${this.numberWithCommas(item.value)}, `;
                }
                if (item.name === "Collected") {
                    str += `Collected: $${this.numberWithCommas(item.value)}, `;
                }
                if (item.name === "Hard Cost") {
                    str += `Hard cost: $${this.numberWithCommas(item.value)}, `;
                }
                if (item.name === "Payment Received") {
                    str += `Payment Received: ${item.value}, `;
                }
                if (item.name === "Explanation") {
                    str += `Explanation: ${item.value} `;
                }
            });

            // if (keys.length) {
            //     values.forEach((val) => {
            //         if ("amount" in val) {
            //             str += `Invoiced: $${this.numberWithCommas(
            //                 val.amount.value
            //             )}, `;
            //         }
            //         if ("collected" in val) {
            //             str += `Collected: $${this.numberWithCommas(
            //                 val.collected.value
            //             )}, `;
            //         }
            //         if ("hard_cost" in val) {
            //             str += `Hard cost: $${this.numberWithCommas(
            //                 val.hard_cost.value
            //             )} `;
            //         }
            //         if ("explanation" in val) {
            //             str += `Explanation: ${val.explanation.value} `;
            //         }
            //     });
            // }

            return str;
        },

        getValueFromChangesOfSale(changes = null, key = null) {
            if (!changes || !key) {
                return null;
            }

            const changesValues = Object.values(JSON.parse(changes));
            if (changesValues.length > 0 && key) {
                const keyValue = changesValues.find(
                    (item) => item.name === key
                );

                if (keyValue) {
                    return `${this.numberWithCommas(keyValue.value)}`;
                }
                return null;
            }
            return null;
        },

        isHasChangeValueOfSale(changes = null, key = null) {
            if (!changes || !key) {
                return false;
            }

            const changesValues = Object.values(JSON.parse(changes));
            if (changesValues.length > 0 && key) {
                const keyValue = changesValues.find(
                    (item) => item.name === key
                );

                if (keyValue) {
                    return true;
                }
                return false;
            }
            return false;
        },

        getValueFromChangesOfInvoice(changes = null, key = null) {
            if (!changes || !key) {
                return "";
            }
            const changesValues = Object.values(JSON.parse(changes));
            if (changesValues.length > 0 && key) {
                const keyValue = changesValues.find(
                    (item) => item.name === key
                );

                if (key === "Payment Received" && keyValue && keyValue.value) {
                    return keyValue.value;
                }

                if (keyValue && keyValue.value) {
                    return `${this.numberWithCommas(keyValue.value)}`;
                }
                return "";
            }
            return "";
        },

        isHasChangeValueOfInvoice(changes = null, key = null) {
            if (!changes || !key) {
                return false;
            }

            const changesValues = Object.values(JSON.parse(changes));
            if (changesValues.length > 0 && key) {
                const keyValue = changesValues.find(
                    (item) => item.name === key
                );

                if (key === "Payment Received") {
                    return true;
                }

                if (keyValue) {
                    return true;
                }
                return false;
            }
            return false;
        },

        numberWithCommas(x) {
            if (!x) {
                return "0";
            }
            return Number(x)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        onEditDealSales(
            sale_id = null,
            deal_id = null,
            period = null,
            sow_index = null,
            upsell_index = null
        ) {
            console.log("Edit", sale_id, deal_id, period);
            this.$store.commit("setEditDealId", deal_id);

            const sales_deals = this.$store.getters.getAllSalesPages;

            if (sales_deals.length) {
                const deal_index = sales_deals.findIndex(
                    (item) => item.deal_id === deal_id
                );

                if (deal_index !== -1) {
                    let sale_index = sales_deals[deal_index].sales.findIndex(
                        (item) => item.id === sale_id
                    );

                    if (sale_index !== -1) {
                        this.$store.commit("setDealIndex", deal_index);
                        this.$store.commit("setSaleIndex", sale_index);

                        this.onChangeSection(SECTIONS.EDIT_SALE_LINE_ITEM);
                    } else if (sow_index !== null && upsell_index !== null) {
                        this.onEditUpsell(sow_index, upsell_index);
                    } else if (period) {
                        sale_index = sales_deals[deal_index].sales.findIndex(
                            (item) => item.period === period
                        );

                        if (sale_index !== -1) {
                            this.$store.commit("setDealIndex", deal_index);
                            this.$store.commit("setSaleIndex", sale_index);

                            this.onChangeSection(SECTIONS.EDIT_SALE_LINE_ITEM);
                        }
                    }
                }
            }
        },

        onEditInvoices() {
            this.onChangeSection(SECTIONS.INVOICES);
        },

        onViewSalesHistory() {
            this.onChangeSection(
                SECTIONS.EDIT_SALE_LINE_ITEM,
                SECTIONS.FINAL_DASHBOARD
            );
        },

        onEditUpsell(sow_index, upsell_index) {
            this.$store.commit("setIndexSOW", sow_index);
            this.$store.commit("setIndexUpsell", upsell_index);
            this.$store.commit("setIsEditUpsell", true);
            this.onChangeSection(
                SECTIONS.DO_YOU_HAVE_UPSELL,
                SECTIONS.FINAL_DASHBOARD
            );
        },

        onDeleteAction(id, name = "") {
            this.isConfirmDeleteModal = true;
            this.deleteIdUpsell = id;
            this.deleteNameSow = name;
        },

        onDeleteUpsell(id = null) {
            if (!id) {
                return;
            }

            try {
                axios
                    .delete(`/api/wizard/deleteDraft/${this.deleteIdUpsell}`)
                    .then(() => {
                        //this.$toast.success("Upsell draft deleted!");
                        this.isConfirmDeleteModal = false;
                        this.deleteIdUpsell = null;
                        this.deleteNameSow = "";
                        this.getData();
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$toast.error(err.response.data.message);
                    });
            } catch (err) {
                console.error(err);
            }
        },

        onCancelDelete() {
            this.isConfirmDeleteModal = false;
            this.deleteIdUpsell = null;
        },

        onHystoricalData(e) {
            e.preventDefault();
            this.onChangeSection(
                SECTIONS.HYSTORICAL_DATA,
                SECTIONS.FINAL_DASHBOARD
            );
        },
    },
};
</script>
